/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-floating-promises */
import { useEffect } from 'react'
import ApexCharts from 'apexcharts'
import { IDadoGrafico2 } from '../..'
import { Flex } from '@chakra-ui/react'
import { HSelect } from '../../../../../Utils/Helper'

interface iChartProps {
  model: IDadoGrafico2[]
  setGrafico: (blob: string) => void
}

export const BarChartIndicativaPDF: React.FC<iChartProps> = ({ model, setGrafico }) => {
  const id = 'dalinho-PDF'
  const valorOrdenado = [...model].sort((a, b) => parseFloat(b.media) - parseFloat(a.media))

  function ObterCor(value: IDadoGrafico2[]): string[] {
    const arr: string[] = []
    value?.forEach(e => {
      if (e.melhoria) {
        arr.push('#F2994A')
      } else {
        arr.push('#27AE60')
      }
    })

    return arr
  }

  async function GerarGrafico(): Promise<void> {
    const element = document.querySelector(`#${id}`)
    if (!element) return

    let animationEnded = false

    const options = {
      series: [{
        data: HSelect(valorOrdenado, e => e.media, false)
      }],
      grid: {
        show: false,
        padding: {
          left: 90,
          right: 90
        }
      },
      chart: {
        type: 'bar',
        height: (valorOrdenado.length * 35) < 721 ? (valorOrdenado.length * 35) : 720,
        width: 1000,
        toolbar: { show: false },
        animations: { enabled: false },

        // ✅ Adiciona listener de evento interno do ApexCharts
        events: {
          animationEnd: () => { animationEnded = true }
        }
      },
      stroke: { show: false, colors: ['#ffffff'] },
      annotations: {
        xaxis: [
          {
            x: 0,
            borderColor: '#c2c2c2',
            fillColor: '#c2c2c2',
            opacity: 0.8
          }
        ]
      },
      dataLabels: {
        enabled: true,
        textAnchor: 'start',
        offsetX: 8,
        offsetY: 0,
        formatter: function (_value: any, series: any) {
          return `C${((series.dataPointIndex as number) + 1)} (${valorOrdenado[series.dataPointIndex].media})`
        },
        style: { colors: ['#000'] }
      },
      colors: ObterCor(valorOrdenado),
      plotOptions: {
        bar: {
          horizontal: true,
          distributed: true,
          barHeight: '14px',
          dataLabels: { position: 'top' }
        }
      },
      legend: { show: false },
      tooltip: {
        x: { show: false },
        y: {
          // Sem isso o tooltip usaria o formatter invisivel do yaxis e perderia o valor
          formatter: function (_value: any, series: any) {
            return valorOrdenado[series.dataPointIndex].media
          },
          title: {
            formatter: function (_value: any, series: any) {
              return valorOrdenado[series.dataPointIndex].nome + ' - '
            }
          },
          marker: { show: false }
        }
      },
      // Sem categories o ApexCharts 3.40 (versao do build de prod) trata o eixo
      // como numerico e desloca cada rotulo uma faixa acima da sua barra.
      xaxis: {
        type: 'category',
        categories: valorOrdenado.map((e, i) => `C${i + 1}`),
        labels: { show: false },
        axisBorder: { show: false },
        crosshairs: { show: false }
      },
      yaxis: {
        // A linha de hover (crosshair) fica em y=0 escondida so por CSS. Com dois
        // graficos na mesma div o cleanup do dataURI esconde a do outro e ela sai
        // como uma linha cinza no topo da imagem do PDF. No PDF nao ha hover.
        crosshairs: { show: false },
        // O ApexCharts 3.40 (build de prod) recua o dataLabel em metade da largura
        // do texto deste formatter e o centraliza pela altura dele. Um espaco de largura
        // zero zera o recuo e mantem a altura da linha, como na 3.54.
        labels: { show: false, formatter: () => '\u200B' },
        max: 1.2,
        min: -1.2,
        axisBorder: { show: false }
      }
    }

    const chart = new ApexCharts(element, options)
    await chart.render()

    // Aguarda o evento animationEnd ou timeout de segurança
    await new Promise<void>((resolve) => {
      const maxWait = setTimeout(() => resolve(), 600)
      const check = setInterval(() => {
        if (animationEnded) {
          clearTimeout(maxWait)
          clearInterval(check)
          resolve()
        }
      }, 50)
    })

    // Captura imagem final
    const dataURIResult = await chart.dataURI()
    let base64: string

    if ('imgURI' in dataURIResult) {
      base64 = dataURIResult.imgURI
    } else {
      base64 = await new Promise<string>((resolve) => {
        const reader = new FileReader()
        reader.onloadend = () => resolve(reader.result as string)
        reader.readAsDataURL(dataURIResult.blob)
      })
    }

    setGrafico(base64)
    await chart.destroy()
  }

  useEffect(() => {
    GerarGrafico()
  }, [model])

  return (
    <Flex w={'100%'} justifyContent={'center'} position={'relative'}>
      <div id={id}></div>
    </Flex>
  )
}
